import p1 from "../../assets/images/all-img/portfolio/p3/p1.png";

export default function ProjectThumbSection() {
	return (
		<div className="fugu-gallery-thumb wow fadeInUpX">
			<img src={p1} alt="" />
		</div>
	);
}
